import { Link } from "react-router-dom";
import { ArrowRight, Globe, MapPin, Zap } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SOLUTIONS = [
  {
    icon: Globe,
    title: "Managed Websites",
    body: "Fast, mobile-friendly websites built, hosted and maintained for you, designed to turn visits into calls and quote requests.",
    href: "/services/websites",
  },
  {
    icon: MapPin,
    title: "Google Profile and Reviews",
    body: "Improve how often your business shows up in local search, keep your Google profile active and build trust through genuine reviews.",
    href: "/services/gbp-seo",
  },
  {
    icon: Zap,
    title: "Google Ads and Follow-Up",
    body: "Optional Google Ads to reach people actively searching, plus faster follow-up so new enquiries are answered before they go cold.",
    href: "/services/lead-generation",
  },
];


export function CoreSolutionsSection() {
  return (
    <section
      className="section-padding bg-background relative overflow-hidden"
      aria-labelledby="solutions-heading"
    >
      <div className="absolute inset-0 grid-pattern opacity-25" />
      <div className="container-wide relative z-10">
        <Reveal className="max-w-2xl mb-10 sm:mb-12">
          <span className="section-badge mb-4">What We Do</span>
          <h2
            id="solutions-heading"
            className="heading-section text-foreground mt-4 mb-5 text-balance"
          >
            The core systems behind stronger{" "}
            <span className="heading-accent">local growth</span>
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground leading-[1.7] prose-cap">
            Start with what your business needs now. Add more only when it makes
            sense.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 sm:gap-6">
          {SOLUTIONS.map((s, i) => (
            <Reveal key={s.title} delay={0.06 * i} className="h-full">
              <Link
                to={s.href}
                className="group h-full flex flex-col rounded-2xl border border-border/60 bg-card shadow-card p-6 sm:p-7 text-left transition-all duration-300 hover:border-primary/30 hover:shadow-xl"
              >
                <s.icon className="w-6 h-6 text-primary mb-4" strokeWidth={1.5} />
                <h3 className="text-lg sm:text-xl font-bold text-foreground mb-2.5 group-hover:text-primary transition-colors">
                  {s.title}
                </h3>
                <p className="text-base text-muted-foreground leading-[1.7] mb-5">
                  {s.body}
                </p>
                <span className="mt-auto inline-flex items-center gap-2 text-base font-semibold text-primary">
                  Learn more
                  <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 text-base font-semibold text-primary hover:underline underline-offset-4"
          >
            View all services
            <ArrowRight className="w-4 h-4" />
          </Link>
          <Link
            to="/free-gbp-audit"
            className="inline-flex items-center gap-2 text-base font-semibold text-foreground/70 hover:text-primary transition-colors"
          >
            Check Your Local Visibility
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
